module.exports = __webpack_public_path__ + "img/toggler.3eb69533.svg";